// Renders an ISO-3166 alpha-2 code as its regional-indicator flag emoji. Returns null for anything
// that isn't two ASCII letters — provider country codes are not always well-formed, and a pair of
// stray indicator symbols renders as visible mojibake rather than a flag.
export function countryFlagEmoji(countryCode: string | null): string | null {
  if (!countryCode || !/^[A-Za-z]{2}$/.test(countryCode)) return null;
  const base = 0x1f1e6 - "A".charCodeAt(0);
  return String.fromCodePoint(...[...countryCode.toUpperCase()].map((letter) => base + letter.charCodeAt(0)));
}
